import { Environment } from 'environment.js'
import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { authenticationSlice } from 'Flux/Slice/Authentication/AuthenticationSlice.js'

export const useUserWasFetched = () => {
  return useSelector(getUserWasFetched)
}
export const getUserWasFetched = (state: typeof State) => {
  return Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT !== 'production'
    ? true
    : state[authenticationSlice.name].userWasFetched
}
